module.exports = __webpack_public_path__ + "static/media/mob15.38799008.jpeg";